@use "../../mixins" as *;
@use "../../variables" as *;

.preview-container {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1010;
  width: 100%;
  height: 100%;
  background: white;
  -webkit-overflow-scrolling: touch;

  @include tablet {
    background: rgba($grey-text, 0.9);
  }

  .image-container {
    position: relative;
    height: 100dvh;
    display: flex;
    justify-content: center;

    div:first-child {
      box-shadow: 1px 1px 20px rgba($black, 0.6);
      width: auto;
      padding: 0;
      display: flex;
    }

    img {
      position: static;
      width: auto;
      max-width: 100%;
      height: 100dvh;
    }

    video {
      position: static;
    }
  }

  .arrow-container {
    z-index: 1001;
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 1rem;
    height: 1rem;
    background: white;
    border-radius: 90px;
    padding: 0.5rem;
    cursor: pointer;

    @include mobile {
      position: fixed;
    }
  }
}